module.exports = __webpack_public_path__ + "img/1.a44a03c9.jpg";